<script setup lang="ts">
    const {
        label,
        icon = 'lucide:trash-2',
        stretch = false,
        align = 'end'
    } = defineProps<{
        label: string;
        icon?: string;
        stretch?: boolean;
        align?: 'start' | 'end';
    }>();

    defineOptions({
        inheritAttrs: false
    });

    const attrs = useAttrs();
</script>

<template>
    <button
        type="button"
        v-bind="attrs"
        class="text-icon-button"
        :class="{ stretch, 'align-start': align === 'start' }"
    >
        {{ label }}
        <Icon :name="icon" />
    </button>
</template>

<style scoped lang="scss">
    .text-icon-button {
        display: flex;
        align-items: center;
        gap: var(--spacing--05);
        background-color: transparent;
        padding: var(--spacing--025);
        color: var(--brand-primary);
        border-radius: var(--border-radius-s);
        justify-content: end;

        &.stretch {
            width: 100%;
        }

        &.align-start {
            justify-content: start;
        }

        :deep(.iconify) {
            color: inherit;
        }

        &:focus-visible {
            outline: 1px solid var(--brand-primary);
        }

        &:hover,
        &:active,
        &:focus {
            color: var(--black);
        }
    }
</style>
